module.exports = __webpack_public_path__ + "static/img/protect.ad60451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protect.png
// module id = UlVN
// module chunks = 21